import { render, staticRenderFns } from "./bannerList.vue?vue&type=template&id=72f41e02&scoped=true"
import script from "./bannerList.vue?vue&type=script&lang=ts"
export * from "./bannerList.vue?vue&type=script&lang=ts"
import style0 from "./bannerList.vue?vue&type=style&index=0&id=72f41e02&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f41e02",
  null
  
)

export default component.exports